@import "~@uipath/apollo-core/src/scss/base-host.scss";

.portal-tooltip {
  .message {
    font-family: $font-normal;
    visibility: hidden;
    text-align: center;
    padding: $pad-l $pad-xxl;
    white-space: normal;
    position: fixed;
    opacity: 0;
    background: var(--color-background-inverse);
    color: var(--color-foreground-inverse);
    font-size: $font-s-size;
    border-radius: $border-thick-l;
    max-width: 250px;
    font-weight: $font-weight-semibold;
    word-wrap: break-word;
    z-index: 2002;
    transition: visibility 0ms linear 0ms, opacity 300ms;
    user-select: none;
    -webkit-user-select: none;
  }

  &.focus,
  &:focus,
  &:hover {
    > .message {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s linear 0s, opacity 300ms;
      transition-delay: 0.5s;
    }
  }
}
